import { DowntimeInfo } from '../../core/api/api/downtime/downtime.service';

export const isMaintenance = (downtimeInfo: DowntimeInfo): boolean => {
  const newDate = new Date();

  return (
    !!downtimeInfo?.timeTo &&
    newDate < new Date(downtimeInfo.timeTo) &&
    !!downtimeInfo?.timeFrom &&
    newDate > new Date(downtimeInfo.timeFrom)
  );
};
